export enum Position {
  Left = 0,
  Right = 1,
  Top = 2
}